export default __webpack_public_path__ + "static/media/Engineering.9c2feb89.svg";